import { useEffect, useState } from 'react';
import { Keyboard, Platform } from 'react-native';

/**
 * Tracks the on-screen keyboard height. Used on phone where the whole form
 * is small enough to lift by full keyboard height regardless of which input
 * is focused (per-input overlap leaves the bottom inputs clipped when the
 * top input is focused).
 */
const useKeyboardHeight = (enabled) => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (!enabled) return;

    const showEvent = Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow';
    const hideEvent = Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide';
    const setIfChanged = (next) => setHeight((prev) => (prev === next ? prev : next));

    const showSub = Keyboard.addListener(showEvent, (e) => setIfChanged(e?.endCoordinates?.height ?? 0));
    const hideSub = Keyboard.addListener(hideEvent, () => setIfChanged(0));

    return () => {
      showSub.remove();
      hideSub.remove();
    };
  }, [enabled]);

  return height;
};

export default useKeyboardHeight;
